import React from 'react'
import styles from './profile-info.styles'
import injectSheet from 'react-jss'
import ProfileInfoHead from './profile-info-head/profile-info-head'
import PupilInfoForm from './pupil-info-form/pupil-info-form.container'
import AddToGroupDialog from '../../dialogs/add-to-group/add-to-group.container'

const ProfileInfo = ({ classes, style }) => (
  <div style={style}>
    <ProfileInfoHead className={classes.profileInfoHead} />
    <PupilInfoForm />
    <AddToGroupDialog />
  </div>
)

export default injectSheet(styles)(ProfileInfo)
